import React from 'react';
import { Spin } from 'antd';
import PropTypes from 'prop-types'
import { LoadingOutlined } from '@ant-design/icons';

const Icon = <LoadingOutlined style={{ fontSize: 35 }} spin />

const Loading = (props) => {
	const { align, cover, className, style } = props
	return (
		<div className={`loading text-${align} cover-${cover} ${className}`} style={{...style}}>
			<Spin indicator={Icon} />
		</div>
	)
}

Loading.propTypes = {
	size: PropTypes.string,
	cover: PropTypes.string,
	className: PropTypes.string
}

Loading.defaultProps = {
	align: 'center',
	cover: 'inline',
	className: ''
};

export default Loading